import { createFileRoute } from '@tanstack/react-router';
import { DraftsRedirectRoute } from './-journeys-redirects';

function DraftsRoute() {
  const { workspaceId } = Route.useParams();
  return <DraftsRedirectRoute workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/drafts')({
  component: DraftsRoute,
});
